import { mergeStyles, MessageBar, MessageBarType } from "office-ui-fabric-react";
import * as React from "react";
import { useTranslation } from "react-i18next";

const wrapper = mergeStyles({
    width: "100%"
})

export interface ResetMessageProps {
  message: string;
}

const ResetMessage: React.FC<ResetMessageProps> = ({ message }) => {
  const { t } = useTranslation("admin");
  return (
    <div className={wrapper}>
      {message && (
        <MessageBar
          messageBarType={
            message === "auth.messages.resetPasswordSuccess"
              ? MessageBarType.success
              : MessageBarType.error
          }
        >
          <p>{t(message)}</p>
        </MessageBar>
      )}
    </div>
  );
};

export default ResetMessage;
